
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { RootState } from '../redux/store';
import { PageRoutes } from './paths';

const PrivateRoute = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  return (isAuthenticated) ? <Outlet /> : <Navigate to={PageRoutes.LOGIN} replace />;
};

export default PrivateRoute;


